import {
    CheckBoxOutlineBlankOutlined,
    CheckBoxOutlined,
    FileDownloadOutlined,
  } from "@mui/icons-material";
  import { Checkbox, FormControlLabel, IconButton, Tooltip } from "@mui/material";
  import React from "react";
  import { Controller, useForm } from "react-hook-form";
  
  import AppConfirmDialog from "components/Shared/AppConfirmDialog";
  import AppForm from "components/Shared/AppForm";
  import BaseAutocomplete from "components/Shared/Base/BaseAutocomplete";
  import DateRangeToggle from "components/Shared/DateRangeToggle";
  import { useAuth } from "hooks";
  import { useLazyListWarehouseAllocationQuery } from "store/services/warehouseAllocationApi";
  import { useLazyGetDDLWarehouseListQuery } from "store/services/warehouseApi";
  import { exportExcelFile } from "utils/exportExcelFile";
import moment from "moment";
import { toast } from "react-toastify";
  
  const EXCEL_DATA_INITIAL_STATE = { dateRange: [], warehouse_id: null };
  
  const ExportWarehouseAllocationExcel = ({ isBusy = false }) => {
    const [showDialog, setShowDialog] = React.useState(false);
    const [showForm, setShowForm] = React.useState(false);
    const { viewEntity } = useAuth();
    // const [activeTab, setActiveTab] = React.useState("Pending"); // Default tab

    const { control, handleSubmit, reset } = useForm({
      defaultValues: EXCEL_DATA_INITIAL_STATE,
    });
  
    const [fetchWarehouseAllocation] = useLazyListWarehouseAllocationQuery();
    const [fetchWarehouses, { data: warehouses, isLoading: loadingWarehouses }] = 
    useLazyGetDDLWarehouseListQuery();

    React.useEffect(() => {
      fetchWarehouses({ 
            account: viewEntity?.entity?.account?._id,
            entity: viewEntity?.entity?._id,
        })
    },[fetchWarehouses, viewEntity?.entity?._id, viewEntity?.entity?.account?._id])

      
  
    const handleDownload = async (data) => {
          const { dateRange } = data;
      
          const fromDate = moment(dateRange[0]).format("MM-DD-YYYY");
          const toDate = moment(dateRange[1]).format("MM-DD-YYYY");
      
          const payload = {
              insurance_id: data?.insurance_id?._id,
              fromDate,
              toDate,
          };
      
          try {
              const responseDate = await fetchWarehouseAllocation(payload).unwrap();
       if (!responseDate.data || responseDate.data.length === 0) 
                  toast.error("No Data Found!");
              const formattedData = responseDate.data.map((row, index) => ({
             
          SN: index + 1,
          "Allocation ID": row.allocation_id || "N/A",
          "Warehouse ID": row.warehouse?.warehouse_id || "N/A",
          "Shipment ID":  row.shipmentrequest?.shipmentId || "N/A",
          "Allocation Time": row.allocation_time || "N/A",
          "Allocated Capacity": row.allocated_capacity || "N/A",          
"Status": row.status === "Pending" 
  ? "Pending" 
  : row.status === "Confirmed" 
  ? "Confirmed" 
  : "Fulfilled",        }));
  
        exportExcelFile({ 
          sheetData: formattedData, 
          fileName: `Warehouse_Allocation_${formattedData?.insurance_id || 'All'}_${new Date().toISOString().slice(0, 10)}.xlsx`
        });
      } catch (error) {
        console.error("Export failed:", error);
      } finally {
        handleReset();
      }
    };
  
    const handleReset = () => {
      setShowDialog(false);
      reset(EXCEL_DATA_INITIAL_STATE);
    };
  
    return (
      <>
        <Tooltip title="Download Excel" arrow>
          <IconButton color="success" onClick={() => setShowDialog(true)}>
            <FileDownloadOutlined />
          </IconButton>
        </Tooltip>
  
        <AppConfirmDialog
          open={showDialog}
          onClose={handleReset}
          onConfirm={handleSubmit(handleDownload)}
          title="Download Warehouse Allocation"
          dialogIcon={() => <FileDownloadOutlined color="success" />}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={showForm}
                onChange={(e) => setShowForm(e.target.checked)}
                icon={<CheckBoxOutlineBlankOutlined />}
                checkedIcon={<CheckBoxOutlined />}
              />
            }
            label="Filter by specific Warehouse"
          />
  
          {showForm && (
            <AppForm loading={isBusy}>
              <AppForm.Content>
                <Controller
                  name="warehouse_id"
                  control={control}
                  render={({ field }) => (
                    <BaseAutocomplete
                      {...field}
                      fullWidth
                      label="Warehouses"
                      options={warehouses || []}
                      getOptionLabel={(option) => option.warehouse_id}
                      isOptionEqualToValue={(option, value) => 
                        option._id === value?._id
                      }
                      loading={loadingWarehouses}
                      loadingText="Loading warehouses..."
                      onChange={(_, value) => field.onChange(value)}
                      value={field.value}
                    />
                  )}
                />
              </AppForm.Content>
            </AppForm>
          )}
  
          <Controller
            name="dateRange"
            control={control}
            rules={{ required: "Date range is required" }}
            render={({ field, fieldState: { error } }) => (
              <DateRangeToggle
                {...field}
                label="Select Date Range"
                error={!!error}
                helperText={error?.message}
                required
              />
            )}
          />
        </AppConfirmDialog>
      </>
    );
  };
  
  export default ExportWarehouseAllocationExcel;